import { useState } from 'react'

import { Sidebar } from '../../components/Sidebar'
import { Navbar } from '../../components/Navbar'
import { CoverSection } from '../../components/CoverSection'
import { InfoSection } from '../../components/InfoSection'
import { Footer } from '../../components/Footer'

import { aboutObj, discoverObj, signupObj } from '../../components/InfoSection/Data'

export function Home() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Sidebar isOpen={isOpen} toggle={toggle} />
      <Navbar toggle={toggle} />
      <CoverSection />
      <InfoSection {...aboutObj} />
      <InfoSection {...discoverObj} />
      <InfoSection {...signupObj} />
      <Footer />
    </>
  )
}